import React from "react";
import "./estimateshipping.scss";
import { IProps } from "./estimateshippinginterface";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../../const/resource";
import { ModalPopup } from "../../../CommonComponent";
import FreightCalculator from "./../FrieghtCalculator/frieghtcalculator";
import helperfunctions from "../../../../utils/helperfunctions";

const ShoppingCartPromo = (props: IProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="estimatetotalShippingView"
        title={t(RESOURCE.MyK_Label_ShoppingCart_Promo_Estimate_Total_Shipping)}
        onClick={() => props?.togglePopupClick()}
        onKeyDown={() => {}}
      >
        {t(RESOURCE.MyK_Label_ShoppingCart_Promo_Estimate_Total_Shipping)}
      </div>
      <div className="shippingCost">
              {props?.shippingCost > 0 ? "$"+ helperfunctions.formatAmount(props?.shippingCost) : ''}
      </div>
      {props?.estShipping ? (
        <>
          <ModalPopup
            ShowModalPopupFooter={true}
            ModalPopupTitle={t(
              RESOURCE.MyK_Label_ShoppingCart_Promo_Freight_Calculator
            )}
            ModalPopupType="medium"
            closeModalPopup={() => props?.togglePopupClick()}
                  >
                      <FreightCalculator cartsDetails={props?.cartsDetails} partNumber="" getItemSummaryDetailsWithoutLoading={props?.getItemSummaryDetailsWithoutLoading} />
          </ModalPopup>
        </>
      ) : null}
    </>
  );
};

export default ShoppingCartPromo;
